import {
  CALLBACK_RESET,
  CALLBACK_SET,
  HISTORY_FILTER_CALLBACK_COUNT,
  UPDATE_NORMAL_CALLBACK,
} from "../constants/action-types";

export function callbackReset(lastCallback = null) {
  return {
    type: CALLBACK_RESET,
    lastCallback,
  };
}

export function setCallbackState(callback: any) {
  return {
    type: CALLBACK_SET,
    callback,
  };
}

export function updateNormalCallback(callback: any) {
  return {
    type: UPDATE_NORMAL_CALLBACK,
    callback,
  };
}

export function setHistoryfilterCallbackCount(callbackCount: number) {
  return {
    type: HISTORY_FILTER_CALLBACK_COUNT,
    callbackCount,
  };
}
